import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  FoldersRepository,
  IFolder,
} from '../../../../state/folders.repository';
import { FoldersService } from '../../../../state/folders.service';
import { DatalistOption } from 'app/state/abstract/base.repository';

@Component({
  selector: 'app-folder-editform',
  templateUrl: './folder-editform.component.html',
  styleUrls: ['./folder-editform.component.scss'],
})
export class FolderEditformComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private repo: FoldersRepository,
    private service: FoldersService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.editForm = this.formBuilder.group({
      name: [this.editedFolder?.name, Validators.required],
      parentFolderId: this.editedFolder?.parentFolderId,
    });
    this.service.loadAllExcept(`${this.editedFolder?.id}`).subscribe((x) => {
      this.folders = x;
    });
  }

  ParentFolderOptions: DatalistOption[] | null = null;
  @Input() set folders(value: IFolder[] | null) {
    if (!value) {
      this.ParentFolderOptions = null;
    } else {
      this.ParentFolderOptions = value.map((x) => ({
        value: x.id,
        label: x.name,
      }));
    }
  }

  editForm: UntypedFormBuilder | any;
  file: File | null = null;
  @Input() editedFolder: Partial<IFolder> | null = null;
  submitErrors: string[] | null = null;

  onSubmit() {
    if (this.editForm && !this.editForm.valid) {
      this.editForm.markAllAsTouched();
      return;
    }
    const name = this.editForm.value?.name.toString();
    const parentFolder = this.editForm.value?.parentFolderId;
    const id = this.editedFolder?.id;
    this.submitErrors = null;
    let updateResult: Observable<IFolder> | undefined;
    updateResult = this.service.editFolder({ id, name, parentFolder });
    if (updateResult) {
      updateResult.subscribe({
        complete: () => {
          this.location.back();
        },
        error: (data) => (this.submitErrors = data),
      });
    }
  }
  updateValue(control: string, value: any) {
    const controlObject = this.editForm?.get(control);
    controlObject?.setValue(value);
    controlObject?.markAsTouched();
  }
}
